export const FlyoutPivot = {
  start: 'start',
  end: 'end',
  dynamic: 'dynamic',
}
